import React from "react";
import { appColors, appType } from "../../utils/appTheme";

/**
 * Etiqueta de sección: MAYÚSCULAS, 11.5px, tracking amplio, gris ink3.
 * Opcional: tick azul a la izquierda y acción a la derecha ("Ver todas").
 */
const SectionLabel = ({ children, action, tick = true, style }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 8,
      margin: `${appType.sectionLabel.fontSize ? 0 : 0}px 0`,
      ...style,
    }}
  >
    {tick && (
      <span
        style={{
          width: 3,
          height: 12,
          borderRadius: 2,
          background: appColors.blue,
        }}
      />
    )}
    <span style={{ ...appType.sectionLabel }}>{children}</span>
    {action && (
      <button
        type="button"
        onClick={action.onClick}
        style={{
          marginLeft: "auto",
          border: "none",
          background: "transparent",
          cursor: "pointer",
          fontFamily: appType.fontFamily,
          fontSize: 12.5,
          fontWeight: 400,
          color: appColors.blue,
          padding: 0,
        }}
      >
        {action.label}
      </button>
    )}
  </div>
);

export default SectionLabel;
